import { type FC } from 'react';
import { Navigate } from 'react-router-dom';

import { type AuthorizedRouteProps } from 'flow-components/routes/interfaces';
import renderBranch from 'common/helpers/renderBranch';

const UnauthorizedRoute: FC<AuthorizedRouteProps> = ({
  authorized,
  redirect,
  children,
}) => {
  return renderBranch(
    authorized,
    <Navigate to={redirect} replace />,
    <>{children}</>
  );
};

export default UnauthorizedRoute;
